import { Flame } from "lucide-react";

const COPY = {
  it: {
    of: "posti su", left: "disponibili", taken: "prenotati",
    soldOut: "Tutti i 300 posti sono esauriti",
    locked: "Prezzo di lancio bloccato per i primi 300 iscritti",
  },
  en: {
    of: "of", left: "launch seats left", taken: "taken",
    soldOut: "All 300 launch seats are gone",
    locked: "Launch price locked for the first 300 members",
  },
};

// La barra appare solo quando le prenotazioni partono davvero.
const MIN_TAKEN = 5;

// Barra dei posti di lancio: "299 of 300 launch seats left" con riempimento proporzionale.
export const SeatsCounter = ({ offer, lang = "en" }) => {
  if (!offer?.seats_total) return null;
  const t = COPY[lang] || COPY.en;
  const total = offer.seats_total;
  const left = Math.max(offer.seats_left ?? 0, 0);
  const taken = Math.max(total - left, 0);
  const pct = Math.min(Math.round((taken / total) * 100), 100);
  const low = left <= 50 && left > 0;
  const bar = offer.sold_out
    ? "bg-slate-500"
    : low
      ? "bg-amber-400"
      : "bg-gradient-to-r from-indigo-400 to-emerald-400";

  if (taken < MIN_TAKEN && !offer.sold_out) {
    return (
      <p
        className="mt-6 flex items-center gap-2 text-sm font-semibold text-emerald-400"
        data-testid="seats-counter-locked"
      >
        <Flame className="h-4 w-4" />
        {t.locked}
      </p>
    );
  }

  return (
    <div className="mt-6" data-testid="seats-counter">
      <div className="flex items-baseline justify-between gap-3">
        <p
          className={`flex items-center gap-2 text-sm font-semibold ${
            offer.sold_out ? "text-slate-400" : low ? "text-amber-400" : "text-emerald-400"
          }`}
          data-testid="seats-counter-label"
        >
          <Flame className={`h-4 w-4 ${low ? "animate-pulse" : ""}`} />
          {offer.sold_out ? (
            t.soldOut
          ) : (
            <>
              <span className="font-mono-num text-base" data-testid="seats-counter-left">
                {left}
              </span>
              <span>
                {t.of} {total} {t.left}
              </span>
            </>
          )}
        </p>
        <span className="font-mono-num text-xs text-slate-400" data-testid="seats-counter-taken">
          {taken} {t.taken}
        </span>
      </div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-slate-800">
        <div
          className={`h-full rounded-full transition-[width] duration-700 ease-out ${bar}`}
          style={{ width: `${Math.max(pct, 2)}%` }}
          data-testid="seats-counter-bar"
        />
      </div>
    </div>
  );
};
